/* constant/development.js */

export default {
    environment: process.env.NODE_ENV,
    webApiUrl: 'https://app.fetuzbook.com',
    appApiUrl: 'https://app.fetuzbook.com',
    webUrl: 'https://app.fetuzbook.com',
    devOutputLink: 'http://61.220.158.183',
    imageUrlNoCdn: 'http://61.220.158.181:5048',
    imageUrl: 'https://d3gm9zoti510ta.cloudfront.net',
    fetuzbookLandlordSchema: 'flypiglandlordsta',
    fetuzbookTenantSchema: 'flypigtenantsta',
    beforeRefreshTokenExpiredDate: 60000,
    gtmId: '5BJ6KD9',
    firebaseConfig: {
        apiKey: "AIzaSyDFyXlXsUGGhSJ1g83-lgE5eALhPscb0y4",
        authDomain: "flypig-web.firebaseapp.com",
        databaseURL: "https://flypig-web.firebaseio.com",
        projectId: "flypig-web",
        storageBucket: "flypig-web.appspot.com",
        messagingSenderId: "986344777671",
        appId: "1:986344777671:web:3a3d6204e1067f3b909be2",
        measurementId: "G-KBY3EZKX40"
    },
    firebaseBizConfig: {
        apiKey: "AIzaSyCtZZvrQQH2096XH0onqRYN4yBOdPw_JRA",
        authDomain: "flypig-web-biz-sta.firebaseapp.com",
        databaseURL: "https://flypig-web-biz-sta.firebaseio.com",
        projectId: "flypig-web-biz-sta",
        storageBucket: "flypig-web-biz-sta.appspot.com",
        messagingSenderId: "442731482633",
        appId: "1:442731482633:web:d487e3d6af66a9c14d72d8",
        measurementId: "G-Z5NSBLT2HK"
    },
    firebaseTenantConfig: {
        apiKey: "AIzaSyBkGfiDb9vySephFRAHNPt8jtMOxXzxNsE",
        authDomain: "flypig-df763.firebaseapp.com",
        databaseURL: "https://flypig-df763.firebaseio.com",
        projectId: "flypig-df763",
        storageBucket: "flypig-df763.appspot.com",
        messagingSenderId: "144585131750",
        appId: "1:144585131750:web:c26802312a8258f2d21d27",
        measurementId: "G-FCWZDV6D0Y"
    }

}


// WEBPACK FOOTER //
// ./src/constant/development.js